import * as API from "../framework/api";
import * as Dialog from "../framework/dialog";
import Alpine from "alpinejs";
import dragula from "dragula";
import { getUITranslation } from "../utils/get_ui_translation";

document.addEventListener("click", async function (event) {
  if (event.target && event.target.matches(".module .js-save-item")) {
    onSaveItem(event.target);
  }
});

document.addEventListener("alpine:init", () => {
  createModuleSequenceItemUpdatesStore();
  registerAlpineBindings();
});

function createModuleSequenceItemUpdatesStore() {
  // this store is created to save updates to MSI so that components use this as the first source of data,
  // then fall back to the values contained in the HTML.
  // see https://github.com/A-World-For-Us/digiforma/pull/7294
  Alpine.store("moduleSequenceItemUpdates", {});
}

function registerAlpineBindings() {
  Alpine.bind("dragula", () => ({
    ":init"() {
      initDragula();
    },
  }));
}

function initDragula() {
  $(".js-sequence-items").each(function () {
    let drake = dragula([this, this], {
      moves: function (_el, _source, handle, _sibling) {
        return handle.closest(".precondition") == null;
      },
    });
    drake.on("drop", onReorderedItems);
  });
}

async function onReorderedItems(_element, target) {
  const items = target.querySelectorAll(".js-sequence-item-container");
  const msi_ids = Array.from(items).map((item) => {
    return item.dataset.msiId;
  });
  const moduleId = target.closest(".module").dataset.id;
  let shouldShowError = false;

  try {
    const result = await API.fetchJSON(p`/ajax/modules/${moduleId}/reindex_sequence`, {
      method: "POST",
      body: { list: msi_ids },
    });

    shouldShowError = !result.success;
  } catch (_error) {
    shouldShowError = true;
  }

  if (shouldShowError) {
    await Dialog.alertError(
      getUITranslation("Changements non sauvegardés"),
      getUITranslation("Les changements n'ont pas pu être sauvegardés. La page va être rechargée.")
    );
    location.reload();
  }
}

async function onSaveItem(buttonEl) {
  const item = buttonEl.closest(".js-sequence-item-container");
  const moduleId = item.closest(".module").dataset.id;
  const resourceType = item.dataset.resourceType;
  const resourceId = item.dataset.resourceId;
  const msiId = item.dataset.msiId;
  const errorToastId = item.dataset.errorToastId;
  const form = buttonEl.closest(".js-sequence-item-container__form");
  const name = form.querySelector(".item-title")?.value ?? undefined;
  const description = form.querySelector(".item-description")?.value ?? undefined;
  const duration = form.querySelector(".item-duration")?.value ?? undefined;
  const durationUE = form.querySelector(".item-duration-ue")?.value ?? undefined;
  const submitButton = form.querySelector(".js-save-item");

  const data = {
    module_sequence_item: {
      name,
      description,
      duration_min: duration,
      duration_ue: durationUE,
    },
    resource_type: resourceType,
    resource: null,
  };

  if (resourceType === "html_doc") {
    const replayable = form.querySelector(".item-replayable")?.checked ?? undefined;
    const show_score = form.querySelector(".item-show_score")?.checked ?? undefined;
    const show_validation = form.querySelector(".item-show_validation")?.checked ?? undefined;

    data.resource = {
      id: resourceId,
    };

    if (show_validation !== undefined) data.resource.show_validation = show_validation;
    if (replayable !== undefined) data.resource.replayable = replayable;
    if (show_score !== undefined) data.resource.show_score = show_score;
  }

  let hasSavedSuccessfully = true;
  try {
    const result = await API.fetchJSON(p`/ajax/modules/${moduleId}/module_sequence_items/${msiId}`, {
      method: "PUT",
      body: data,
    });

    hasSavedSuccessfully = result.success;
  } catch (_error) {
    hasSavedSuccessfully = false;
  }

  if (hasSavedSuccessfully) {
    // change button text to data saved !
    submitButton.innerText = submitButton.dataset.saved;
    submitButton.classList.add("js-save-item-clicked");
    // save all updates to store, then new data is not lost when we click on another module and go back to this one without reloading the page.
    saveModuleSequenceItemUpdateToStore(msiId, data.module_sequence_item);

    // change button text to save data
    setTimeout(() => {
      submitButton.innerText = submitButton.dataset.custom;
      submitButton.classList.remove("js-save-item-clicked");
    }, 2300);
  } else {
    window.toast.show("#" + errorToastId);
  }
}

function saveModuleSequenceItemUpdateToStore(id, moduleSequenceItem) {
  Alpine.store("moduleSequenceItemUpdates")[id] = moduleSequenceItem;
}
